module.exports = __webpack_public_path__ + "static/media/machine_error.afbf9116.svg";